export default __webpack_public_path__ + "static/media/dreamstime_s_25350097.b3924381.jpg";